module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "teinte"
    }
  }, [_c('section', {
    attrs: {
      "id": "teinteDesktop"
    }
  }, [_c('div', {
    staticClass: "rel",
    attrs: {
      "id": "Teinte"
    }
  }, [(this.$route.name === 'Module') ? _c('section', {
    class: _vm.relatedProducts(),
    attrs: {
      "id": "productsModule"
    }
  }, [_c('h2', {
    staticClass: "uppercase txtCenter ff-medium rel",
    attrs: {
      "id": "title"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("modulePage.productsModule")) + "\n                    "), (
    (_vm.product && (_vm.product.type.name === 'product' && _vm.hasAccessUpdate('product_manager'))) ||
    (_vm.product && (_vm.product.type.name === 'module' && _vm.hasAccessUpdate('module_manager')))
  ) ? _c('button', {
    staticClass: "btn abs pointer mobileNot ff-light uppercase",
    attrs: {
      "id": "edit"
    },
    on: {
      "click": _vm.addRelatedItem
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("product.manage")) + "\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.getRelProductsLength > 0) ? _c('section', {
    staticClass: "flexContainer fw-w mobileNot tabletNot"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "full",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.getRelatedProducts), function(products, index) {
    return _c('swiper-slide', {
      key: products.id,
      staticClass: "modulesWrapper flexContainer fd-c ai-c jc-fs"
    }, [_c('div', {
      staticClass: "txtCenter slideContent",
      on: {
        "mouseover": function($event) {
          _vm.onHoverRelProduct(index);
        }
      }
    }, [_c('figure', [_c('img', {
      staticClass: "center imgSlide",
      staticStyle: {
        "max-width": "150px"
      },
      attrs: {
        "src": _vm.getImgPath(products.figures.small, 'small'),
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "ff-bold capitalize name"
    }, [_vm._v(_vm._s(_vm.getTranslate(products.terms.name)))])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('div', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.toModuleProduct(products.id, products.type.name);
        }
      }
    }, [(_vm.rollIndex3 === index) ? _c('div', {
      staticClass: "roll-over box-overlay flexContainer full mobileNot tabletNot",
      on: {
        "mouseleave": _vm.onHoverLeave
      }
    }, [_c('div', {
      staticClass: "txtCenter center"
    }, [_c('h4', {
      staticClass: "ff-medium"
    }, [_vm._v(_vm._s(_vm.getTranslate(products.terms.name)))]), _vm._v(" "), (products.type.name != 'module' && products.infosArticle.hasOwnProperty('client_ref1')) ? _c('p', {
      staticClass: "ff-light"
    }, [_vm._v("\n                                                " + _vm._s(products.infosArticle.client_ref1.componentProperty.value) + "\n                                            ")]) : _vm._e(), _vm._v(" "), (products.type.name != 'module' && products.infosArticle.hasOwnProperty('client_ref1')) ? _c('p', {
      staticClass: "ff-light"
    }, [_vm._v("\n                                                " + _vm._s(products.infosArticle.diam_ref1.componentProperty.value) + "\n                                            ")]) : _vm._e()])]) : _vm._e()])])], 1)
  }), _vm._v(" "), (_vm.getRelProductsLength > 6) ? _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }) : _vm._e(), _vm._v(" "), (_vm.getRelProductsLength > 6) ? _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  }) : _vm._e(), _vm._v(" "), (_vm.getRelModulesLength > 6) ? _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  }) : _vm._e()], 2)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getRelProductsLength > 0) ? _c('section', {
    staticClass: "mobileOnly flexContainer"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOptionMobile
    }
  }, [_vm._l((_vm.getRelatedProducts), function(products) {
    return _c('swiper-slide', {
      key: products.id
    }, [_c('div', {
      staticClass: "txtCenter slideContent"
    }, [_c('div', {
      staticClass: "linkToItem block abs pointer full",
      on: {
        "click": function($event) {
          _vm.toModuleProduct(products.id, products.type.name);
        }
      }
    }), _vm._v(" "), _c('figure', [_c('img', {
      staticClass: "center imgSlide",
      attrs: {
        "src": _vm.getImgPath(products.figures.small, 'small'),
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "ff-bold capitalize"
    }, [_vm._v(_vm._s(_vm.getTranslate(products.terms.name)))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.getRelModulesLength > 0) ? _c('section', {
    staticClass: "mobileOnly"
  }, [(_vm.getRelModulesLength > 0) ? _c('h2', {
    staticClass: " relModule uppercase ff-medium"
  }, [_vm._v(_vm._s(_vm.$t("modulePage.moduleProduct")))]) : _vm._e(), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOptionMobile
    }
  }, [_vm._l((_vm.getRelatedModules), function(modules) {
    return _c('swiper-slide', {
      key: modules.id
    }, [_c('div', {
      staticClass: "txtCenter slideContent"
    }, [_c('div', {
      staticClass: "linkToItem block abs pointer full",
      on: {
        "click": function($event) {
          _vm.toModuleProduct(modules.id, modules.type.name);
        }
      }
    }), _vm._v(" "), _c('figure', [_c('img', {
      staticClass: "center imgSlide",
      attrs: {
        "src": _vm.getImgPath(modules.figures.small, 'small'),
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "ff-bold capitalize"
    }, [_vm._v(_vm._s(_vm.getTranslate(modules.terms.name)))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)], 1) : _vm._e(), _vm._v(" "), (this.$route.name === 'Product') ? _c('section', {
    staticClass: "rel mobileNot tabletNot",
    attrs: {
      "id": "otherProducts"
    }
  }, [_c('h2', {
    staticClass: "uppercase txtCenter ff-medium rel",
    attrs: {
      "id": "title"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("modulePage.moduleProduct")) + "\n                    "), _c('button', {
    staticClass: "btn abs pointer mobileNot ff-light uppercase",
    attrs: {
      "id": "edit"
    },
    on: {
      "click": _vm.addRelatedItem
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("product.manage")) + "\n                    ")])]), _vm._v(" "), _c('section', _vm._b({
    staticClass: "flexContainer fw-w mobileNot tabletNot"
  }, 'section', _vm.displayFolModules(), false), [_c('swiper', {
    ref: "mySwiper",
    staticClass: "full",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.getRelatedModules), function(modules, index) {
    return (_vm.getRelModulesLength) ? _c('swiper-slide', {
      key: modules.id,
      staticClass: "modulesWrapper flexContainer fd-c ai-c jc-fs",
      class: _vm.itemClassModule(index)
    }, [_c('div', {
      staticClass: "txtCenter slideContent",
      on: {
        "mouseover": function($event) {
          _vm.onHoverModule(index);
        }
      }
    }, [_c('figure', [_c('img', {
      staticClass: "center relatedPicture",
      staticStyle: {
        "max-width": "150px"
      },
      attrs: {
        "src": _vm.getImgPath(modules.figures.small, 'small'),
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "ff-bold capitalize name"
    }, [_vm._v(_vm._s(_vm.getTranslate(modules.terms.name)))])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('div', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.toModuleProduct(modules.id, modules.type.name);
        }
      }
    }, [(_vm.rollIndex2 === index) ? _c('div', {
      staticClass: "roll-over box-overlay flexContainer full mobileNot tabletNot",
      on: {
        "mouseleave": _vm.onHoverLeave
      }
    }, [_c('div', {
      staticClass: "txtCenter center"
    }, [_c('h4', {
      staticClass: "ff-medium"
    }, [_vm._v(_vm._s(_vm.getTranslate(modules.terms.name)))]), _vm._v(" "), (modules.type.name != 'product' && modules.infosArticle.hasOwnProperty('client_ref1')) ? _c('p', {
      staticClass: "ff-light"
    }, [_vm._v("\n                                                " + _vm._s(modules.infosArticle.client_ref1.componentProperty.value) + "\n                                            ")]) : _vm._e(), _vm._v(" "), (modules.type.name != 'product' && modules.infosArticle.hasOwnProperty('client_ref1')) ? _c('p', {
      staticClass: "ff-light"
    }, [_vm._v("\n                                                " + _vm._s(modules.infosArticle.diam_ref1.componentProperty.value) + "\n                                            ")]) : _vm._e()])]) : _vm._e()])])], 1) : _vm._e()
  }), _vm._v(" "), (_vm.getRelModulesLength > 6) ? _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }) : _vm._e(), _vm._v(" "), (_vm.getRelModulesLength > 6) ? _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  }) : _vm._e(), _vm._v(" "), (_vm.getRelModulesLength > 6) ? _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  }) : _vm._e()], 2)], 1)]) : _vm._e()])]), _vm._v(" "), (_vm.showModal) ? _c('ModalRelated', {
    attrs: {
      "itemType": _vm.product.type,
      "relatedItem": _vm.relatedItem
    },
    on: {
      "closeModal": function($event) {
        _vm.modalClose($event);
      },
      "relatedItemSaved": function($event) {
        _vm.addedItem($event);
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0d60b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/Related.vue
// module id = 3067
// module chunks = 0